import React from "react";
import Navbar from "../navbar/Navbar";
import AboutusImg from "../../../Assets/about_puphub-pica.jpeg";
import Footer from "../../footer/Footer"
import { Helmet } from "react-helmet-async";

interface AboutCardProps {
  title: string;
  content: string;
  backgroundColor?: string;
}

const AboutCard: React.FC<AboutCardProps> = ({ 
  title, 
  content, 
  backgroundColor = "#D9D9D9" 
}) => (
  <div
    style={{ backgroundColor }}
    className="p-8 rounded-xl text-center shadow-lg transform transition-transform duration-300 hover:scale-105"
  >
    <h3 className="text-3xl md:text-2xl lg:text-3xl font-bold mb-4">
      {title}
    </h3>
    <p className="text">{content}</p>
  </div>
);

const AboutusPage: React.FC = () => {
  const aboutSections = [
    {
      title: "OUR STORY",
      content: "PupHub began with a simple idea — to create a space where pet lovers can connect, share, and grow together. What started as a small idea has now blossomed into a thriving digital community for pet parents across the country. Whether you're here to share your dog's latest adventure, read pet news, or make new furry friends, PupHub is your trusted companion in this journey of love and pawsitivity."
    },
    {
      title: "OUR FACILITY",
      content: "PupHub is more than just an app — it's a platform designed for connection and care. With features like pet story sharing, real-time chat with fellow pet parents, community news, and access to local pet services like clinics, groomers, vets, and pharmacies, we've built a space where pet parenting is easier and more enjoyable. All you need is your PIN code to discover what's nearby!"
    },
    {
      title: "OUR COMMITMENT",
      content: "We're committed to building a safe, respectful, and engaging community for all pet lovers. Your voice matters here — whether you're posting a blog, offering advice, or searching for the nearest vet. At PupHub, we're not just creating a platform; we're growing a family that celebrates every tail wag and paw print."
    }
  ];

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://puphub.co.in/aboutus" />
        <title>PupHub | About Us</title>
        <meta
          name="description"
          content="Learn more about PupHub's mission, values, and our journey."
        />
      </Helmet>
      
      <Navbar />
      
      <div
        className="w-[100vw] h-[30vh] sm:h-[80vh] relative"
        style={{
          backgroundImage: `url('https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/about_puphub-pica.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        role="img"
        aria-label="About PupHub - our pet community platform"
      />
      
      <div className="m-5">
        <section className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {aboutSections.map((section, index) => (
            <AboutCard
              key={`about-section-${index}`}
              title={section.title}
              content={section.content}
            />
          ))}
        </section>

        <section className="text-center mt-16" aria-labelledby="community-cta">
          <h2 id="community-cta" className="sr-only">Join Our Community</h2>
          <p className="text-xl text-white">
            Join the PupHub community today and become part of a growing family
            of pet lovers. Share stories, connect with fellow pet parents, and
            discover everything your furry friend needs — all in one place.
            Let's grow together, one paw at a time!
          </p>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default AboutusPage;